import {mainUrl} from '../config'
import axios from 'axios'

export const loadAllItemsApi = async () =>{
  try{
    const response = await axios.get(`${mainUrl.API_URL}/site/all`)
    return response.data
  }
  catch(error){
    throw error
  }
}

export const getIndexApi = async (id) =>{
  try{
    const response = await axios.get(`${mainUrl.API_URL}/site/${id}`)
    return response.data
  }
  catch(error){
    throw error
  }
}

export const getDailyDataApi = async (data) =>{
  try{
    const response = await axios.post(`${mainUrl.API_URL}/site/daily_data`, data , {
      headers: {
        'accept': 'application/json',
        'Content-Type': 'multipart/form-data',
      },
    })
    return response.data
  }
  catch(error){
    throw error
  }
}